"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcSpace = void 0;
var polished_1 = require("polished");
var index_1 = require("./index");
var calcSpace = function (n, step, adjustment) {
    if (n === void 0) { n = 0; }
    if (step === void 0) { step = index_1.STEP; }
    if (adjustment === void 0) { adjustment = 0; }
    return (0, polished_1.rem)(step * n + adjustment);
};
exports.calcSpace = calcSpace;
//# sourceMappingURL=calc-space.js.map